const Dialog = {
  install: (Vue) => {
    Vue.component('Dialog', () => {
      return import('./components/index.vue')
    })
  }
}

export default Dialog
